module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-body"
  }, [_c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "md": 12
    }
  }, [(_vm.loading) ? _c('h1', {
    staticClass: "pageTitle"
  }, [_c('i', {
    staticClass: "fa fa-list-alt",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("  " + _vm._s(_vm.$t('static.warehouse.update.title')))]) : _c('h1', {
    staticClass: "pageTitle"
  }, [_c('i', {
    staticClass: "fa fa-list-alt",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("  " + _vm._s(_vm.warehouse.name))])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "md": 12
    }
  }, [_c('div', {
    staticClass: "flex",
    staticStyle: {
      "justify-content": "flex-end"
    }
  }, [_c('div', {
    staticClass: "btn-group margin-b-10 margin-r-10"
  }, [_c('button', {
    staticClass: "btn info el-button",
    attrs: {
      "type": "button",
      "disabled": "disabled"
    }
  }, [_vm._v(_vm._s(_vm.$t('static.warehouse.transactionNavigation.addTransaction')))]), _vm._v(" "), _c('el-button', {
    staticClass: "btn btn-danger dropdown-toggle dropdown-toggle-split",
    attrs: {
      "type": "button",
      "data-toggle": "dropdown"
    },
    on: {
      "click": _vm.toggleDropdownTransactions
    }
  }, [_c('span', {
    staticClass: "sr-only"
  })]), _vm._v(" "), _c('div', {
    staticClass: "dropdown-menu",
    class: {
      show: _vm.dropdownStateTransactions
    }
  }, [_c('a', {
    staticClass: "dropdown-item",
    attrs: {
      "role": "button",
      "href": ("#/inventory/stocks/create#" + (_vm.warehouse.id))
    }
  }, [_vm._v(_vm._s(_vm.$t('static.warehouse.transactionNavigation.stockCount')))]), _vm._v(" "), _c('a', {
    staticClass: "dropdown-item",
    attrs: {
      "role": "button",
      "href": ("#/inventory/adjustment/create/stock#" + (_vm.warehouse.id))
    }
  }, [_vm._v(_vm._s(_vm.$t('static.warehouse.transactionNavigation.stockAdjustment')))]), _vm._v(" "), _c('a', {
    staticClass: "dropdown-item",
    attrs: {
      "role": "button",
      "href": ("#/inventory/transfer/create#" + (_vm.warehouse.id))
    }
  }, [_vm._v(_vm._s(_vm.$t('static.warehouse.transactionNavigation.transfer')))]), _vm._v(" "), _c('a', {
    staticClass: "dropdown-item",
    attrs: {
      "role": "button",
      "href": ("#/inventory/purchase/create#" + (_vm.warehouse.id))
    }
  }, [_vm._v(_vm._s(_vm.$t('static.warehouse.transactionNavigation.purchase')))])])], 1)])])], 1), _vm._v(" "), (_vm.loading) ? _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }]
  }, [_c('br'), _c('br')]) : _c('div', {
    staticClass: "whiteWrapper"
  }, [_c('el-tabs', {
    on: {
      "tab-click": _vm.switchTab
    },
    model: {
      value: (_vm.tabIndex),
      callback: function($$v) {
        _vm.tabIndex = $$v
      },
      expression: "tabIndex"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": _vm.$t('form.warehouse.basicInformation'),
      "name": "1"
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 12,
      "lg": 8
    }
  }, [_c('fieldset', {
    staticClass: "margin-b-10 min-h-350"
  }, [_c('legend', [_vm._v(_vm._s(_vm.$t('form.warehouse.warehouseInformation')))]), _vm._v(" "), (!_vm.loading) ? _c('v-form', {
    attrs: {
      "form": _vm.formBasicInformation,
      "translation": "form.warehouse",
      "hasLabel": true
    }
  }) : _vm._e()], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 12,
      "lg": 8
    }
  }, [_c('fieldset', {
    staticClass: "margin-b-10 min-h-350"
  }, [_c('legend', [_vm._v(_vm._s(_vm.$t('form.warehouse.contactInformation')))]), _vm._v(" "), (!_vm.loading) ? _c('v-form', {
    attrs: {
      "form": _vm.formContactInformation,
      "translation": "form.warehouse.contact",
      "hasLabel": true
    }
  }) : _vm._e()], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 12,
      "lg": 8
    }
  }, [_c('fieldset', {
    staticClass: "margin-b-10 min-h-350"
  }, [_c('legend', [_vm._v(_vm._s(_vm.$t('form.warehouse.addressInformation')))]), _vm._v(" "), (!_vm.loading) ? _c('v-form', {
    attrs: {
      "form": _vm.formAddressInformation,
      "translation": "form.warehouse.address",
      "hasLabel": true
    }
  }) : _vm._e()], 1)])], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": _vm.$t('static.warehouse.formTabs.products'),
      "name": "2"
    }
  }, [_c('el-row', {
    staticStyle: {
      "margin-bottom": "20px"
    },
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    staticStyle: {
      "padding": "0px"
    },
    attrs: {
      "sm": 24,
      "md": 8,
      "lg": 8,
      "xl": 8
    }
  }, [_c('div', {
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.productSearch),
      callback: function($$v) {
        _vm.productSearch = $$v
      },
      expression: "productSearch"
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "el-button el-button--default small",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.onProductSearch
    }
  }, [_vm._v(_vm._s(_vm.$t('button.search')))])], 1), _vm._v(" "), _c('el-checkbox', {
    model: {
      value: (_vm.hideOutOfStock),
      callback: function($$v) {
        _vm.hideOutOfStock = $$v
      },
      expression: "hideOutOfStock"
    }
  }, [_vm._v(_vm._s(_vm.$t('static.warehouse.products.hideOutOfStock')))]), _vm._v(" "), (_vm.isDestructionWarehouse) ? _c('button', {
    staticClass: "el-button el-button--default small",
    staticStyle: {
      "margin-bottom": "4px"
    },
    attrs: {
      "disabled": !this.multipleSelection.length,
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.destroySelectedProducts($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('static.warehouse.products.bulkDestroyProducts')))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [(_vm.productShowAction) ? _c('el-row', {
    staticClass: "bulkActions",
    staticStyle: {
      "margin-bottom": "10px"
    },
    attrs: {
      "gutter": 5
    }
  }, [_c('el-col', {
    attrs: {
      "md": 8,
      "lg": 6,
      "xl": 4
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.productSelectedCount) + " products selected")])]), _vm._v(" "), (!_vm.isDestructionWarehouse) ? _c('el-col', {
    staticStyle: {
      "text-align": "right"
    },
    attrs: {
      "md": 3,
      "lg": 3,
      "xl": 2
    }
  }, [(_vm.productShowAction) ? _c('label', [_vm._v(_vm._s(_vm.$t('productActions.select.label')) + " ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (!_vm.isDestructionWarehouse) ? _c('el-col', {
    attrs: {
      "md": 13,
      "lg": 15,
      "xl": 18
    }
  }, [_c('button', {
    staticClass: "el-button el-button--default small",
    staticStyle: {
      "margin-bottom": "4px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.onSelectAction('minStockLevel')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('button.setMinimumStock')))])]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.productsLoading) ? _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.productsLoading),
      expression: "productsLoading"
    }]
  }, [_c('br'), _c('br'), _c('br'), _c('br'), _c('br')]) : (_vm.productList) ? _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.productList,
      "row-class-name": _vm.rowClass,
      "stripe": "",
      "default-sort": {
        prop: 'name',
        order: 'ascending'
      }
    },
    on: {
      "row-click": function($event) {
        return _vm.showDetails($event)
      },
      "selection-change": _vm.handleSelectionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "50"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": _vm.$t('static.warehouse.products.name'),
      "sortable": "",
      "order": ""
    }
  }), _vm._v(" "), (_vm.warehouse.typeName != 'Destruction') ? _c('el-table-column', {
    attrs: {
      "prop": "producer",
      "label": _vm.$t('static.warehouse.products.producer'),
      "sortable": ""
    }
  }) : _vm._e(), _vm._v(" "), ((_vm.warehouse.typeName == 'Destruction' || _vm.warehouse.typeName == 'Standard') && _vm.hasProduction() === true) ? _c('el-table-column', {
    attrs: {
      "prop": "batchName",
      "label": _vm.$t('static.warehouse.products.batchName'),
      "sortable": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t('static.warehouse.products.qty'),
      "sortable": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('p', {
          style: (scope.row.qty < scope.row.minimumStockLevel ? 'color:darkred' : '')
        }, [_vm._v(_vm._s(scope.row.qty))])]
      }
    }])
  }), _vm._v(" "), (!_vm.isDestructionWarehouse) ? _c('el-table-column', {
    attrs: {
      "prop": "minimumStockLevel",
      "label": _vm.$t('static.warehouse.products.minimumStockLevel'),
      "sortable": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('el-table-column', {
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(!_vm.isDestructionWarehouse) ? _c('el-button', {
          staticClass: "small",
          attrs: {
            "size": "mini",
            "type": "primary"
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              return _vm.activateModal(scope.row)
            }
          }
        }, [_vm._v(_vm._s(_vm.$t('button.edit').toUpperCase()))]) : _vm._e(), _vm._v(" "), (_vm.isDestructionWarehouse) ? _c('el-button', {
          staticClass: "small",
          attrs: {
            "size": "mini",
            "type": "primary"
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              return _vm.destroyProduct(scope.row)
            }
          }
        }, [_vm._v(_vm._s(_vm.$t('button.destroy').toUpperCase()))]) : _vm._e()]
      }
    }])
  })], 1) : _c('el-alert', {
    attrs: {
      "title": _vm.$t('static.warehouse.products.noDataMsg'),
      "type": "warning"
    }
  }), _vm._v(" "), _c('el-row', [_c('el-col', [_c('div', {
    staticClass: "pagination"
  }, [_c('v-pagination', {
    attrs: {
      "sizePerPage": _vm.perPage,
      "pagination": _vm.warehouseProducts.pagination,
      "switchFunction": _vm.allProduct
    }
  })], 1)])], 1)], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": _vm.$t('static.warehouse.formTabs.transactions'),
      "name": "3"
    }
  }, [_c('el-row', {
    staticStyle: {
      "margin-top": "10px",
      "margin-bottom": "10px"
    },
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "sm": 24,
      "md": 1,
      "lg": 1,
      "xl": 1
    }
  }, [_c('label', [_vm._v("Filter: ")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "sm": 24,
      "md": 3,
      "lg": 3,
      "xl": 3
    }
  }, [(_vm.hasProduction()) ? _c('el-select', {
    staticClass: "el-col-24",
    attrs: {
      "filterable": "",
      "remote": "",
      "clearable": "",
      "size": "medium",
      "placeholder": "Batch",
      "remote-method": _vm.getFilterBatches,
      "loading": _vm.batchFilter.loading
    },
    on: {
      "change": function($event) {
        return _vm.eventBatchFilter($event)
      },
      "clear": _vm.clearBatchFilter,
      "focus": _vm.focusBatchFilter
    },
    model: {
      value: (_vm.batchFilter.value),
      callback: function($$v) {
        _vm.$set(_vm.batchFilter, "value", $$v)
      },
      expression: "batchFilter.value"
    }
  }, _vm._l((_vm.batchFilter.options), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1) : _vm._e()], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "sm": 24,
      "md": 3,
      "lg": 3,
      "xl": 3
    }
  }, [_c('el-select', {
    staticClass: "el-col-24",
    attrs: {
      "filterable": "",
      "remote": "",
      "clearable": "",
      "size": "medium",
      "placeholder": "Product name",
      "remote-method": _vm.getFilterProducts,
      "loading": _vm.productFilter.loading
    },
    on: {
      "change": function($event) {
        return _vm.eventProductFilter($event)
      },
      "clear": _vm.clearProductFilter,
      "focus": _vm.focusProductFilter
    },
    model: {
      value: (_vm.productFilter.value),
      callback: function($$v) {
        _vm.$set(_vm.productFilter, "value", $$v)
      },
      expression: "productFilter.value"
    }
  }, _vm._l((_vm.productFilter.options), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "sm": 24,
      "md": 3,
      "lg": 3,
      "xl": 3
    }
  }, [_c('el-select', {
    staticClass: "el-col-24",
    attrs: {
      "filterable": "",
      "size": "medium",
      "placeholder": "Transaction code",
      "loading": _vm.typeFilter.loading
    },
    on: {
      "change": function($event) {
        return _vm.eventTransactionsV2Filter($event)
      }
    },
    model: {
      value: (_vm.typeFilter.value),
      callback: function($$v) {
        _vm.$set(_vm.typeFilter, "value", $$v)
      },
      expression: "typeFilter.value"
    }
  }, _vm._l((_vm.typeFilter.options), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [(_vm.transactionLoading) ? _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.transactionLoading),
      expression: "transactionLoading"
    }]
  }, [_c('br'), _c('br'), _c('br'), _c('br'), _c('br')]) : _vm._e(), _vm._v(" "), (!_vm.transactionLoading && _vm.transactionListV2.length < 1) ? _c('div', {
    staticClass: "whiteWrapper full-w flex justify-center",
    staticStyle: {
      "padding": "50px"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t('static.warehouse.transactions.noDataMsg')) + "\n          ")]) : _vm._e(), _vm._v(" "), (_vm.transactionListV2.length > 0 && !_vm.transactionLoading) ? _c('v-table', {
    attrs: {
      "list": _vm.transactionListV2,
      "noDataMessage": _vm.$t('static.warehouse.transactions.noDataMsg'),
      "link": _vm.transactionLink,
      "linkKey": "via",
      "rowKey": "id",
      "translation": "static.warehouse.transactions.table"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.transactionListV2.length > 0) ? _c('el-row', [_c('el-col', [_c('div', {
    staticClass: "pagination"
  }, [_c('v-pagination', {
    attrs: {
      "sizePerPage": _vm.perPage,
      "pagination": _vm.transactionsV2.pagination,
      "switchFunction": _vm.all
    }
  })], 1)])], 1) : _vm._e()], 1)], 1)], 1)], 1), _vm._v(" "), (!_vm.loading) ? _c('div', {
    staticClass: "full-w flex justify-center buttons_under_main_body"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'warehouse.index'
      }
    }
  }, [_c('el-button', {
    staticClass: "dark"
  }, [_vm._v(_vm._s(_vm.$t('button.cancel').toUpperCase()))])], 1), _vm._v(" "), _c('el-button', {
    staticClass: "outline",
    attrs: {
      "loading": _vm.formBasicInformation.loading
    },
    on: {
      "click": _vm.update
    }
  }, [_vm._v(_vm._s(_vm.$t('button.save').toUpperCase()))])], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0c0acf64","hasScoped":false}!./src/app/pages/withNavigation/warehouse/edit/edit.html
// module id = 2907
// module chunks = 1